/* eslint-disable indent */
import React from "react";
import styles from "../stylesER.module.scss";

export const SoftwareDSModal = ({
  isOpen,
  monthIndex,
  currentYear,
  variant, // "publicidad" | "gestion"
  meses,
  licencias,
  setLicencias,
  previewLocal,
  setPreviewLocal,
  getDolarValue,
  moneda,
  pais,
  localString,
  // Variant A (publicidad) only
  pantallasCarteleria,
  costoPublicidadNeto,
  // Variant C (gestion) only
  pantallasActivas,
  onSave,
  onClose,
}) => {
  if (!isOpen || monthIndex === null) return null;

  const isPublicidad = variant === "publicidad";
  const title = isPublicidad ? "Software DS (Publicidad)" : "Software DS (Gestión & Contenidos)";

  const fechaDia1 = `${currentYear}-${String(monthIndex + 1).padStart(2, "0")}-01`;
  const dolarDia1 = getDolarValue(fechaDia1);

  const handleLicenciasChange = (e) => {
    const cant = parseInt(e.target.value) || 0;
    setLicencias(cant);
    setPreviewLocal(Math.round(cant * 10.99 * dolarDia1));
  };

  const contentClass = isPublicidad
    ? `${styles.modalContentSoftware} ${styles.editCostModal}`
    : `${styles.modalContent} ${styles.editCostModal}`;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={contentClass} onClick={(e) => e.stopPropagation()}>
        <h3 className={styles.modalTitle}>
          {title} - {meses[monthIndex]} {currentYear}
        </h3>

        {/* Info box: fecha, dólar, precio licencia */}
        <div style={{ marginBottom: "20px", padding: "12px", backgroundColor: "#f0f8ff", borderRadius: "6px" }}>
          <strong>Fecha factura:</strong> 01-{String(monthIndex + 1).padStart(2, "0")}-{currentYear}
          <br />
          <strong>Dólar observado (día 1):</strong> {moneda(pais)}
          {dolarDia1.toLocaleString(localString(pais), { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          <br />
          <strong>Precio por licencia:</strong> US$ 10.99
        </div>

        {/* Variant C: pantallas activas (solo lectura) */}
        {!isPublicidad && (
          <div style={{ marginBottom: "20px" }}>
            <label style={{ display: "block", marginBottom: "8px", fontWeight: "600" }}>
              Cantidad de pantallas activas (calculado)
            </label>
            <div
              style={{
                padding: "12px",
                backgroundColor: "#f5f5f5",
                borderRadius: "6px",
                fontSize: "1.1rem",
                fontWeight: "700",
                textAlign: "right",
                color: "#666",
              }}
            >
              {pantallasActivas || 0}
            </div>
          </div>
        )}

        {/* Input licencias */}
        <div style={{ marginBottom: "20px" }}>
          <label style={{ display: "block", marginBottom: "8px", fontWeight: "600" }}>
            {isPublicidad ? "Cantidad de licencias contratadas (factura OnSign)" : "Cantidad de licencias (editable)"}
          </label>
          <input
            type="number"
            value={licencias || ""}
            onChange={handleLicenciasChange}
            min="0"
            placeholder="0"
            style={{
              width: "100%",
              padding: "12px",
              fontSize: "1.1rem",
              textAlign: "right",
              borderRadius: "6px",
              border: "1px solid #ccc",
              appearance: "none",
              MozAppearance: "textfield",
              WebkitAppearance: "none",
            }}
            onWheel={(e) => e.preventDefault()}
          />
          <style jsx>{`
            input[type="number"]::-webkit-inner-spin-button,
            input[type="number"]::-webkit-outer-spin-button {
              -webkit-appearance: none;
              margin: 0;
            }
            input[type="number"] {
              -moz-appearance: textfield;
            }
          `}</style>
        </div>

        {/* Variant A: Total en US$ */}
        {isPublicidad && (
          <div style={{ marginBottom: "20px" }}>
            <label style={{ display: "block", marginBottom: "8px", fontWeight: "600" }}>Total factura US$</label>
            <div
              style={{
                padding: "16px",
                backgroundColor: "#f0f8ff",
                borderRadius: "6px",
                fontSize: "1.3rem",
                fontWeight: "700",
                textAlign: "right",
                color: "#1565c0",
              }}
            >
              US${" "}
              {(licencias * 10.99).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </div>
          </div>
        )}

        {/* Total moneda local */}
        <div style={{ marginBottom: isPublicidad ? "20px" : "30px" }}>
          <label style={{ display: "block", marginBottom: "8px", fontWeight: "600" }}>
            {isPublicidad ? `Total factura ${moneda(pais).trim()}` : `Total ${moneda(pais).trim()}`}
          </label>
          <div
            style={{
              padding: "16px",
              backgroundColor: "#e8f5e8",
              borderRadius: "6px",
              fontSize: "1.3rem",
              fontWeight: "700",
              textAlign: "right",
              color: "#1b5e20",
            }}
          >
            {moneda(pais)}
            {previewLocal.toLocaleString(localString(pais), {
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            })}
          </div>
        </div>

        {/* Variant A: Info cartelería */}
        {isPublicidad && (
          <div style={{ marginBottom: "30px", padding: "12px", backgroundColor: "#fff3e0", borderRadius: "6px" }}>
            <strong>Licencias asociadas a cartelería:</strong> {pantallasCarteleria || 0}
            <br />
            <strong>Total costo asignado a publicidad (quitando cartelería):</strong> {moneda(pais)}
            {Math.max(0, costoPublicidadNeto || 0).toLocaleString(localString(pais), {
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            })}
          </div>
        )}

        <div className={styles.modalActions}>
          <button className={styles.btnSave} onClick={onSave}>
            Guardar
          </button>
          <button className={styles.btnCancel} onClick={onClose}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};
